import { useAsync } from 'react-use';
import { GenericComponent } from '@model/content';
import { TourTestimonial } from '@model/iceberg';
import { ToursApi } from '@model/iceberg/service/tours';
import { TourTestimonialHeroContainer } from '@components/testimonial-hero/TourTestimonialHeroContainer';

interface TestimonialContentContainerProps extends Pick<GenericComponent, 'path' | 'tripType' | 'destination'> {
  testimonials?: Array<TourTestimonial> | null;
}

export const TestimonialContentContainer = ({
  path,
  tripType,
  destination,
  testimonials
}: TestimonialContentContainerProps) => {
  const { value: testimonialData } = useAsync(async () => {
    return testimonials ? testimonials : await new ToursApi().getTourTestimonials({ path, tripType });
  }, [path]);

  if (!tripType || !testimonialData || !testimonialData.length) {
    return null;
  }

  return (
    <TourTestimonialHeroContainer
      testimonials={testimonialData}
      path={path}
      destinationName={destination?.display || ''}
      tripType={tripType}
    />
  );
};
